import { INotificationsContextState } from '@app/models/NotificationsContextState'
import { ApplicationState } from '@app/store'
import {
  IAccessTokenState,
  selectAccessToken,
} from '@app/store/modules/account'
import {
  actionCreators,
  selectError,
  selectIsLoading,
  selectIsOpen,
  selectIsReadingAll,
  selectItems,
  selectUnseenCount,
} from '@app/store/modules/systemNotifications'
import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import {
  ISystemNotificationsIconProps,
  SystemNotificationsIcon,
} from '../components/SystemNotificationsIcon'

export default connect(
  (state: ApplicationState, ownProps: ISystemNotificationsIconProps) =>
    createStructuredSelector<
      ApplicationState,
      IAccessTokenState & INotificationsContextState
    >({
      accessToken: selectAccessToken(),
      error: selectError(ownProps.context),
      isLoading: selectIsLoading(ownProps.context),
      isOpen: selectIsOpen(ownProps.context),
      isReadingAll: selectIsReadingAll(ownProps.context),
      items: selectItems(ownProps.context),
      unseenCount: selectUnseenCount(ownProps.context),
    }),
  actionCreators,
)(SystemNotificationsIcon)
